import { Component, computed, inject, input } from '@angular/core';
import { ModalService } from '@card-software/library';
import { PoReceiptCoverage } from '../../../models/po-receipt/po-receipt';
import { ReceivedCoverageModalComponent } from '../../accounts-payable/_modals/received-coverage-modal/received-coverage-modal.component';

/**
 * The banner above a payment's totals when any selected document would pay more than was received (#5662).
 * Names the documents as links — one dialog explains one document — so the reason is a click away even when
 * the offending row is on another page of the table or hidden by a filter.
 */
@Component({
  selector: 'app-received-coverage-banner',
  templateUrl: './received-coverage-banner.component.html',
})
export class ReceivedCoverageBannerComponent {
  private readonly modalService = inject(ModalService);

  /** The selected documents' check results; only those over what was received are shown. */
  readonly coverages = input<PoReceiptCoverage[]>([]);

  readonly over = computed(() => this.coverages().filter((c) => c.exceedsReceived));

  open(coverage: PoReceiptCoverage): void {
    this.modalService.open(ReceivedCoverageModalComponent, { modalClass: 'modal_large' }, { coverage }).subscribe();
  }
}
